<template>
  <div></div>
</template>

<script>
import { Auth } from '../service'

export default {
  data() {
    return {}
  },
  created() {
    if (!this.$route.query.refresh || !this.$route.query.escola) {
      return
    }

    if (Auth.checkAccessToken()) {
      this.$router.push('/')
    }

    localStorage.setItem('escola', this.$route.query.escola)
    localStorage.setItem('soae_refresh_token', this.$route.query.refresh)
    Auth.refreshAccessToken().then(() => {
      this.$router.push('/')
    })
  }
}
</script>
